"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60mm",
    height: "60mm",
    viewBox: "0 0 170.08 170.08"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M138.19,170.08H31.89a3.55,3.55,0,0,1,0-7.09h106.3a3.55,3.55,0,0,1,0,7.09Z",
    fill: "#005271"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.28,145.7a10.57,10.57,0,0,1-7.52,3.12H21.26v3.54a3.54,3.54,0,0,0,3.54,3.55H145.28a3.55,3.55,0,0,0,3.54-3.55v-45.2Z",
    fill: "#005271"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M152.36,0H17.72a3.54,3.54,0,0,0-3.55,3.54V138.19a3.54,3.54,0,0,0,3.55,3.54h85a3.52,3.52,0,0,0,2.51-1l49.59-49.6a3.54,3.54,0,0,0,1-2.51v-85A3.54,3.54,0,0,0,152.36,0ZM106.3,129.64V92.13h37.51Z",
    fill: "#005271"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M106.3,129.88h-.1a.26.26,0,0,1-.15-.24V92.13a.25.25,0,0,1,.25-.25h37.51A.25.25,0,0,1,144,92a.25.25,0,0,1,0,.27l-37.51,37.51A.26.26,0,0,1,106.3,129.88Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M143.81,92.13,106.3,129.64V92.13h37.51m0-.5H106.3a.5.5,0,0,0-.5.5v37.51a.5.5,0,0,0,.31.46.58.58,0,0,0,.19,0,.51.51,0,0,0,.35-.15l37.51-37.51a.49.49,0,0,0,.11-.55.51.51,0,0,0-.46-.3Z",
    fill: "#005271"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M68.64,20.48A10.2,10.2,0,0,0,58.46,30.67c0,5.4,9.26,19.48,9.65,20.08a.64.64,0,0,0,.53.29.62.62,0,0,0,.53-.29c.4-.6,9.66-14.68,9.66-20.08A10.2,10.2,0,0,0,68.64,20.48Zm0,14.64a4.46,4.46,0,1,1,4.46-4.45A4.46,4.46,0,0,1,68.64,35.12Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M42.25,62.25A16.23,16.23,0,0,0,26,78.46c0,8.6,14.73,31,15.36,32a1,1,0,0,0,.85.45,1,1,0,0,0,.84-.45c.63-1,15.37-23.37,15.37-32A16.23,16.23,0,0,0,42.25,62.25Zm0,23.3a7.09,7.09,0,1,1,7.09-7.09A7.1,7.1,0,0,1,42.25,85.55Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M130.46,42.22a13.59,13.59,0,0,0-13.57,13.57c0,7.21,12.34,26,12.87,26.78a.85.85,0,0,0,.7.38.87.87,0,0,0,.71-.38C131.7,81.77,144,63,144,55.79A13.59,13.59,0,0,0,130.46,42.22Zm0,19.51a5.94,5.94,0,1,1,5.94-5.94A5.95,5.95,0,0,1,130.46,61.73Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M107.43,58.83a2.41,2.41,0,0,1-1.31-.39L82.94,43a2.37,2.37,0,0,1,2.63-3.94l23.17,15.46a2.36,2.36,0,0,1-1.31,4.32Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M63.63,92.09a2.37,2.37,0,0,1-1-4.51l47-21.93a2.36,2.36,0,1,1,2,4.28l-47,21.94A2.35,2.35,0,0,1,63.63,92.09Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;